module.exports = __webpack_public_path__ + "media/emails/send-notice-6826ee2a.png";